import type { AxiosError } from 'axios'

import { useMutation } from '@tanstack/react-query'

import type { AuthenticateUserMutationError } from '@/utils/api/user-service'
import type { LoginRequest } from '@/utils/api/user-service/models'

import { handleError } from '@/lib/utils'
import { authenticateUser } from '@/utils/api/user-service'
import { LoginRequestApp } from '@/utils/api/user-service/models'

// Copilot: Create a TanStack Query hook. Strong types for input/output.
// Set staleTime, select shape, error normalization to ApiResponse.
// No UI code; export the hook only.
// Token helpers are provided by '@/lib/session' for other modules

export type LoginInput = Pick<LoginRequest, 'usernameOrEmail' | 'password'> & {
  rememberMe?: boolean
}

export interface LoginSuccess {
  accessToken: string
  tokenType: string
}

export type LoginError = AxiosError<{ success?: boolean; message?: string }>

// moved to src/lib/session

// toUserSummary is centralized in useCurrentUser

// storeAuthToken, clearAuthToken, getAuthToken are exported from '@/lib/session'

export function useLogin() {
  // We'll manually fetch the profile after authentication instead of using the generated hook inside mutation.
  return useMutation<
    Awaited<ReturnType<typeof authenticateUser>>,
    AuthenticateUserMutationError,
    LoginInput
  >({
    mutationKey: ['login'],
    mutationFn: async (input: LoginInput) => {
      const res = await authenticateUser({
        usernameOrEmail: input.usernameOrEmail,
        password: input.password,
        app: LoginRequestApp.LEAVE_PORTAL,
      })
      return res
    },
    onError: error => handleError(error, 'Sign Up failed'),
  })
}
